import React, { useContext, useRef, useEffect } from 'react';
import { Parallax, Background } from 'react-parallax';
import Container from "react-bootstrap/Container";
import Diamonds from '../componentes/common/Diamonds';

function Seccion (props) {

    return (
        <div
        className={`section ${(props.theme === 'dark') ? 'dark-section' : ''} pos-relative ovf-hidden`}
        id={props.id}
        >
            {/* -----renderProp: "renderLayer"-----*/}
            <Parallax strength={500}>
                {
                    (props.epicBarDirection) ? 
                        <div className={`epic-bar --${props.epicBarDirection} --${props.theme}`}></div>
                        :
                        ""
                }
                <div className="dis-table w-100 full-section">
                    <div className="dis-table-section">
                        <div className="dis-table-cell">
                            <div className="dis-inline-block w-100">
                                <Container>
                                    {props.children}
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
                <Background className="custom-bg">
                    <Diamonds theme={props.theme}/>
                </Background>
            </Parallax>
        
        </div>
    );
}
export default Seccion;